import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/folders';

export const getFileTypes = async () => await ajax('GET', `${rootUrl}/get/file-types`);

export const createFolder = async (payload) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));

export const updateFolder = async ({ folderKey, payload }) =>
  await ajax('PUT', `${rootUrl}/${folderKey}`, JSON.stringify(payload));

export const deleteFolder = async (folderKey) => await ajax('DELETE', `${rootUrl}/${folderKey}`);
